import Debug from 'debug';
import { ExamStateMachineAbstractState, ExamStateMachineCommonEvents } from './state'
import { ExamStateMachineData } from '../data'

const debug = Debug('exam-canceled-state')

export class ExamCanceledState extends ExamStateMachineAbstractState<ExamStateMachineCommonEvents> {

  public readonly name = 'canceled'

  constructor() {
    super()
  }

  enter() {
    debug('enter')
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    // NOP
  }
}
